import { App, Plugin } from "vue";
import VueApexCharts from "vue3-apexcharts";

const ApexChartsPlugin = {
    install( app: App< Element > ) {
        app.use( VueApexCharts as Plugin );
    }
}
export default ApexChartsPlugin;
